module.exports = __webpack_public_path__ + "img/symbol_2.b3e6aca6.png";